/**
 * Utilitário centralizado de cores para status de faturamento.
 * Qualquer alteração aqui reflete em todas as telas (Analista, Administrador, Acompanhamento).
 *
 * Códigos:
 *   1 - Pendente de Envio    → amarelo
 *   2 - Pendente de Aprovação → laranja
 *   3 - Aprovado             → azul
 *   4 - Faturado             → verde
 *   5 - Reprovado            → vermelho
 */
export function getFaturamentoStatusClasse(statusCodigo?: number): string {
  if (statusCodigo === 1) return 'bg-yellow-100 text-yellow-800'
  if (statusCodigo === 2) return 'bg-orange-100 text-orange-800'
  if (statusCodigo === 3) return 'bg-blue-100 text-blue-800'
  if (statusCodigo === 4) return 'bg-green-100 text-green-800'
  if (statusCodigo === 5) return 'bg-red-100 text-red-800'
  return 'bg-gray-100 text-gray-800'
}
